export default "__VITE_ASSET__1oeETrKi__"